import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';
import EachUser from './EachUser';

class Users extends Component {
	constructor(props) {
		super(props);
		this.state = {
			list: {},
			message: '',
			total: 0,
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			myEmail: '',
			ready: false,
			error: false,
			errorMessage: ''
		}
	}

	componentWillMount() {
		var self = this;
		Api.parseToken(this.state.token, function(response) {
			self.setState({
				myEmail: response.email
			}, function() {
				self.getUsers();
			});
		});
	}

	getUsers = () => {
		var self = this;
		Api.getUsers(JSON.stringify({ token: self.state.token, myEmail: self.state.myEmail }), function(response) {
			self.setState({
				list: response.list,
				total: response.total_results,
				message: response.message,
				ready: true
			});
		});
	}

	deleteUser = (id) => {
		var self = this;
        if(window.confirm("Are you sure you want to delete this user? This action cannot be undone.")) {
            this.setState({
                ready: false
            }, function() {
                Api.deleteUser(JSON.stringify({ token: this.state.token, id: id }), function(response) {
                    if(response.status === 'Deleted') {
                    	self.getUsers();
                    }
                });
            });
        } else {
            return false;
        }
	}

	eachEntry = (res, i) => {
		return(
			<div key={i}>
				{i === 0 ?
					<div className="row titleRow mobileHide">
						<div style={{width: '15%', float: 'left', cursor: 'default'}}>First Name</div>
						<div style={{width: '15%', float: 'left', cursor: 'default'}}>Last Name</div>
						<div style={{width: '25%', float: 'left', cursor: 'default'}}>Email Address</div>
						<div style={{width: '10%', float: 'left', cursor: 'default'}}>Permissions</div>
						<div style={{width: '10%', float: 'left', cursor: 'default'}}>Centre</div>
						<div style={{width: '15%', float: 'left', cursor: 'default'}}>Last Login</div>
						<div style={{width: '10%', float: 'left', cursor: 'default'}}>Actions</div>
					</div> :
					null
				}
				<EachUser key={i} index={i} deleteUser={this.deleteUser}>
					{res}
				</EachUser>
			</div>
		);
	}

    render() {
    	return(
    		<div className="blockCtr patients br10 sh1">
    			<div className="blockHeader br10Top">
    				<Link to="/" className="backBtn br10TopLeft"><span className="fas fa-chevron-left"></span></Link>
    				<h3>Users</h3>
    				<Link to="/users/new" className="addBtn br10TopRight">New User</Link>
    			</div>
    			<div className="blockInfo">
					<div className="table">
						{this.state.error ? this.state.errorMessage : this.state.ready ? this.state.list.map(this.eachEntry) : <img src={Preloader} alt="Fresenius Preloader" className="preloader" style={{display: 'block', maxHeight: 'auto'}} />}
					</div>
    			</div>
    		</div>
    	);
    }
}

export default Users;



// WEBPACK FOOTER //
// ./src/components/Users.js